// extracted by mini-css-extract-plugin
export default {"notation-template":"styles_notation-template__COULr"};